import { Card, CardContent, CardHeader, CardProps, Typography } from "@mui/material";
import { COLORS } from "assets";
import { PropsWithChildren, ReactNode } from "react";

export interface FormSectionProps extends Omit<CardProps, "title"> {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  dense?: boolean;
}

export default function FormSection({
  title,
  description,
  action,
  dense,
  children,
  sx,
  ...rest
}: PropsWithChildren<FormSectionProps>) {
  return (
    <Card
      elevation={0}
      sx={{
        bgcolor: COLORS.surface.card,
        borderRadius: `${COLORS.radius.md}px`,
        boxShadow: COLORS.shadow.card,
        border: `1px solid ${COLORS.surface.border}`,
        mb: 2,
        ...sx
      }}
      {...rest}
    >
      {title ? (
        <CardHeader
          title={
            typeof title === "string" ? (
              <Typography variant="h4" sx={{ color: COLORS.surface.primaryText, fontWeight: 600, fontSize: 18 }}>
                {title}
              </Typography>
            ) : (
              title
            )
          }
          subheader={
            description
              ? typeof description === "string"
                ? (
                    <Typography variant="body2" sx={{ color: COLORS.surface.secondaryText, mt: 0.5, lineHeight: 1.5 }}>
                      {description}
                    </Typography>
                  )
                : description
              : undefined
          }
          action={action}
          sx={{
            pb: 0,
            "& .MuiCardHeader-action": { m: 0, alignSelf: "center" },
            "& .MuiCardHeader-subheader": { mt: 0.5 }
          }}
        />
      ) : null}
      <CardContent sx={{ pt: title ? 1.5 : 2, px: dense ? 2 : 3, pb: dense ? 2 : 3, "&:last-child": { pb: dense ? 2 : 3 } }}>
        {children}
      </CardContent>
    </Card>
  );
}
